import apiService from 'src/enviroment';
import { loaderService } from './loaderService';

const postPlaca = async (params) => {
  loaderService.show();
  try {
    const response = await apiService.post('/reportes/buscador/placa/', params);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
};

const postDocument = async (params) => {
  loaderService.show();
  try {
    const response = await apiService.post('/reportes/buscador/cedulas/', params);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
};

const postPoints = async (params) => {
  loaderService.show();
  try {
    const response = await apiService.post(
      '/reportes/buscador/puntaje/',
      params,
    );
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
};

const getPqrs = async ({ params }) => {
  loaderService.show();
  try {
    const response = await apiService.get(`/pqrs/consultar?cedula=${params}`);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
}

const postPqrsFiles = async ({ params }) => {
  loaderService.show();
  try {
    const response = await apiService.post('/pqrs/consultar', params);
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    return false;
  } finally {
    loaderService.hide();
  }
}
export { postDocument, postPlaca, postPoints, getPqrs, postPqrsFiles };
